export default class ThemeController {
  constructor({
    selector = "#image_block_ma2bpx6q",
    headerSelector = ".header",
    buffer = 0
  } = {}) {
    const html = document.documentElement;
    if (html.dataset.root !== "true") return;

    const target = document.querySelector(selector);
    const header = document.querySelector(headerSelector);

    let ticking = false;
    let headerH = header ? header.offsetHeight : 0;

    const setTheme = (next) => {
      if (html.dataset.theme === next) return;
      html.dataset.theme = next;
      html.classList.remove("no-theme-transitions");
    };

    const measureHeader = () => {
      headerH = header ? header.offsetHeight : 0;
    };

    const compute = () => {
      if (!target) return; // if no target, keep green
      const rect = target.getBoundingClientRect();
      const topLine = headerH + buffer;
      const passed = rect.bottom <= topLine;       // image block has been scrolled past
      setTheme(passed ? "beige" : "switch");
      ticking = false;
    };

    const requestCompute = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(compute);
    };

    html.classList.add("no-theme-transitions");
    setTheme("switch");                             // green on load
    requestAnimationFrame(() => compute());

    if (header && "ResizeObserver" in window) {
      const ro = new ResizeObserver(() => {
        measureHeader();
        requestCompute();
      });
      ro.observe(header);
    }

    window.addEventListener("scroll", requestCompute, { passive: true });
    window.addEventListener("resize", () => {
      measureHeader();
      requestCompute();
    });
  }
}
